import React from "react";
import dateFns from "date-fns";
import es from "date-fns/locale/es";

import { images } from "../../../../../assets/images";
import { capitalizeFirstLetter } from "../../../../../utils";

interface CalendarHeaderProps {
  newDate: Date;
  setShowMonths: React.Dispatch<React.SetStateAction<boolean>>;
  setShowYears: React.Dispatch<React.SetStateAction<boolean>>;
  onClickPrevMonth: () => void;
  onClickNextMonth: () => void;
  onClickNextYear: () => void;
  onClickPrevYear: () => void;
}

const CalendarHeader = ({
  newDate,
  setShowMonths,
  setShowYears,
  onClickPrevMonth,
  onClickNextMonth,
  onClickNextYear,
  onClickPrevYear,
}: CalendarHeaderProps) => {
  return (
    <div className="calendar-header">
      <div className="current-month">
        <p onClick={() => setShowMonths(true)}>
          {capitalizeFirstLetter(
            dateFns.format(newDate, "MMMM", {
              locale: es,
            })
          )}
        </p>
        <div className="pick-arrow top">
          <img
            src={images.IconArrowUpLightBlue}
            alt="Seleccionar mes previo"
            onClick={onClickPrevMonth}
          />
        </div>
        <div className="pick-arrow bottom">
          <img
            src={images.IconArrowDownLightBlue}
            alt="Seleccionar mes siguiente"
            onClick={onClickNextMonth}
          />
        </div>
      </div>

      <div className="current-year">
        <p onClick={() => setShowYears(true)}>
          {capitalizeFirstLetter(
            dateFns.format(newDate, "YYYY", {
              locale: es,
            })
          )}
        </p>
        <div className="pick-arrow top" onClick={onClickNextYear}>
          <img src={images.IconArrowUpLightBlue} alt="Seleccionar año siguiente" />
        </div>
        <div className="pick-arrow bottom" onClick={onClickPrevYear}>
          <img src={images.IconArrowDownLightBlue} alt="Seleccionar año previo" />
        </div>
      </div>

      <div className="calendar-arrow-container">
        <div className="arrows arrow-left" onClick={onClickPrevMonth}>
          <img src={images.IconArrowLeftBlue} alt="Seleccionar mes siguiente" />
        </div>

        <div className="arrows arrow-right" onClick={onClickNextMonth}>
          <img src={images.IconArrowRightBlue} alt="Seleccionar mes previo" />
        </div>
      </div>
    </div>
  );
};

export default CalendarHeader;
